import { useCurrentPath } from '@/hooks/general/useCurrentPath/useCurrentPath';

export const getUrlPart = (
    currentPath: ReturnType<typeof useCurrentPath>,
    index: number,
): string => {
    const parts = currentPath.asPath.split('/');
    if (index < 0) {
        return parts[parts.length + index];
    } else {
        return parts[index];
    }
};
